import './modules/slider';
import './modules/menu';
import './modules/general';
import './modules/autocompleteFields';
import './modules/rangeSlider';
import './modules/lightbox';
import './modules/maps';



// WEBPACK FOOTER //
// ./assets/js/src/index.js